









































import { ICanvasElementDrawArgs } from '@/models/marketingCenter/canvas';
import { EMarketingCenterFormats } from '@/models/marketingCenter/format';
import { IMarketingCenterPost } from '@/models/marketingCenter/post';
import { draw } from '@/models/marketingCenter/template';
import MarketingCenterCanvasPreview from '@/components/organisms/MarketingCenterCanvasPreview/MarketingCenterCanvasPreview.vue';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    MarketingCenterCanvasPreview
  }
})
export default class MarketingCenterCanvas extends Vue {
  @Prop({ required: true }) refreshState!: any;
  @Prop({ required: true }) post!: IMarketingCenterPost;
  @Prop({ required: true }) format!: EMarketingCenterFormats;

  previewRefreshState = 0;
  imgWidth = 251;
  imgHeight = 251;
  scale = 1;
  source = '';

  loading = true;

  ctx: CanvasRenderingContext2D | null = null;

  created() {
    this.onResize();
    window.addEventListener('resize', this.onResize);
  }

  destroyed() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize() {
    const offsetY = 380;
    const offsetX = 1050;

    let value = (window.innerHeight - offsetY) / this.imgHeight;

    if (value * this.imgWidth > window.innerWidth - offsetX) {
      value = (window.innerWidth - offsetX) / this.imgWidth;
    }

    if (value >= 2.2) {
      value = 2.2;
    }

    if (value >= 1) this.scale = Math.round(value * 100) / 100;
  }

  mounted() {
    this.renderCanvas();
  }

  @Watch('refreshState')
  onPostChange() {
    window.requestAnimationFrame(() => this.renderCanvas());
  }

  @Watch('format')
  onFormatChange() {
    this.loading = true;

    window.requestAnimationFrame(() => this.renderCanvas());
  }

  async renderCanvas() {
    const base64 = await this.generateBase64();

    if (base64 && this.formatData) {
      this.imgWidth = +this.formatData.canvas.width;
      this.imgHeight = +this.formatData.canvas.height;
      this.source = base64;

      this.onResize();
      this.previewRefreshState++;
    }
  }

  async getFormData() {
    const data = new FormData();

    for (const format of this.post.template.formats) {
      const base64 = await this.generateBase64(format, false);

      if (base64) {
        const blob = this.generateBlob(base64);
        data.append('files', blob, `${format.key}.png`);
      }
    }

    return data;
  }

  async generateBase64(format = this.formatData, fromPreview = true) {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    if (ctx && format) {
      const ratioX = format.asset.width / +format.canvas.width;
      const ratioY = format.asset.height / +format.canvas.height;

      canvas.width = +format.asset.width;
      canvas.height = +format.asset.height;
      ctx.scale(ratioX, ratioY);

      this.ctx = ctx;

      await draw(
        ctx,
        this.post.template,
        format.key,
        this.drawArgs({
          width: +format.canvas.width,
          height: +format.canvas.height
        }),
        fromPreview
      );

      return canvas.toDataURL('image/png', 1);
    }
  }

  drawArgs(dimensions?: {
    width: number;
    height: number;
  }): ICanvasElementDrawArgs {
    return {
      ...this.post,
      business: this.business,
      canvas: dimensions || this.canvasDimensions
    };
  }

  get canvasDimensions() {
    let width = this.imgWidth;
    let height = this.imgHeight;

    if (this.formatData) {
      width = +this.formatData.canvas.width;
      height = +this.formatData.canvas.height;
    }

    return {
      width,
      height
    };
  }

  generateBlob(dataURL: string) {
    const BASE64_MARKER = ';base64,';
    let parts;
    let contentType;
    let raw;

    if (dataURL.indexOf(BASE64_MARKER) == -1) {
      parts = dataURL.split(',');
      contentType = parts[0].split(':')[1];
      raw = decodeURIComponent(parts[1]);

      return new Blob([raw], {
        type: contentType
      });
    }

    parts = dataURL.split(BASE64_MARKER);
    contentType = parts[0].split(':')[1];
    raw = window.atob(parts[1]);

    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);

    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }

    return new Blob([uInt8Array], {
      type: contentType
    });
  }

  get formatData() {
    return this.post.template.formats.find(
      format => format.key === this.format
    );
  }

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business || {};
  }
}
